import { cart } from '~/store/cart'
import { checkout } from '~/store/checkout'
import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'

export function getProductMaximumOrderQuantity (product: any, currentProductQuantity: number): number {
    return currentProductQuantity + Number((product?.maximumOrderQuantity || 0) - getCartQuantityForProduct(product.id))
}

export function productMaximumReached (product: any): boolean {
    return getCartQuantityForProduct(product.id) >= (product?.maximumOrderQuantity || 0)
}

export function getCartQuantityForProduct (productId: string | number): number {
    const cartProductsWithIds = Object.values(cart().getCartProducts).filter(product => {
        return Number(product.id) === productId
    })
    return cartProductsWithIds.reduce((total: number, product: any) => {
        return total + product.quantity
    }, 0)
}

export function productIsAvailable (product: any | number): boolean {
    const currentProductIsAvailable = product.available === 'AVAILABLE'
    const currentProductHasCorrectDispatchType = product.availableFor === null || product.availableFor === '' || (product.availableFor === DispatchTypeOrderBuddy.DELIVER && checkout().input.dispatchType === DispatchTypeOrderBuddy.DELIVER) || (product.availableFor === DispatchTypeOrderBuddy.PICK_UP && checkout().input.dispatchType === DispatchTypeOrderBuddy.PICK_UP)
    const isProductMaximumReached = productMaximumReached(product)
    return currentProductIsAvailable && currentProductHasCorrectDispatchType && !isProductMaximumReached
}
